import { Injectable } from '@angular/core';
import { Observable, Subject } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class ItemFeeSetupStateService {
  hasUnsavedSetupChanges = false;
  setupsUnavailable = false;
  // Nothing can be compared against a list that has not arrived, so a save in that window would
  // look clean and drop the merchant's edits.
  setupsPending = false;
  // the review dialog names a setup the merchant switched to; it only has the id
  setupNames: Record<number, string> = {};

  // A setup the method has just switched to is not counted against it until the method itself is
  // saved, so the listed counts go stale the moment that happens.
  private readonly methodSaved = new Subject<void>();

  get methodSaved$(): Observable<void> {
    return this.methodSaved.asObservable();
  }

  notifyMethodSaved(): void {
    this.methodSaved.next();
  }

  reset(): void {
    this.hasUnsavedSetupChanges = false;
    this.setupsUnavailable = false;
    this.setupsPending = false;
    this.setupNames = {};
  }
}
